<template>
  <div class="redirect">
    <div class="title" v-if="!originalLink">
      <h3>Hệ thống đang xử lý, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading" v-if="!originalLink">
      <div class="el-icon-loading"></div>
    </div>
    <div class="title" v-if="originalLink">
      <h3>
        Nhấn vào đây <a :href="originalLink" class="link">vào đây</a> để chuyển
        trang
      </h3>
    </div>
    <dialog-handler-error-v2
      :openDialog="isOpenHandleErrorDialog"
      :content="content"
      :countDown="10"
      v-if="isEnableHandleErrorDialog"
      @redirect="goToDashboard"
    ></dialog-handler-error-v2>
  </div>
</template>

<script>
import DialogHandlerErrorV2 from "../../components/DialogHandlerErrorV2";
import shortLinkService from "../../services/shortLinkService";
import errorMessageFilter from "../../filters/errorMessageFilter";

export default {
  name: "intermediateViewDetail",
  components: {DialogHandlerErrorV2},

  data() {
    return {
      isOpenRedirectDialog: false,
      url: null,
      content: null,
      isOpenHandleErrorDialog: false,
      isEnableHandleErrorDialog: false,

      shortLink: null,
      originalLink: null
    };
  },

  computed: {
    code() {
      return this.$route.params.code;
    },
    isSafariBrowser() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1;
    }
  },

  watch: {
    isOpenHandleErrorDialog(newValue) {
      newValue && (this.isEnableHandleErrorDialog = newValue);
    }
  },

  created() {
    this.loadShortLink()
      .then(() => this.doRouting())
      // .catch(() => {
      //   this.content = errorMessageFilter({errorCode: "unknownError"});
      //   this.isOpenHandleErrorDialog = true;
      // });
  },

  methods: {
    loadShortLink() {
      return shortLinkService
        .findByCode(this.code)
        .then(response => (this.shortLink = response.data));
    },

    doRouting() {
      if (this.shortLink) {
        this.originalLink = this.shortLink.originalLink;
        if (!this.isSafariBrowser) {
          window.open(this.originalLink, "_blank");
        } else {
          let safariWindow = window.open();
          safariWindow.location = this.originalLink;
        }
      } else {
        this.content = errorMessageFilter({errorCode: "shortLink.notFound"});
        this.isOpenHandleErrorDialog = true;
      }
    },

    goToDashboard() {
      this.$router.replace({name: "beforeEnterApp"});
    }
  }
};
</script>

<style>
.redirect {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.link {
  text-decoration: underline;
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/views/shortLink/short-link.vue